const sortByPrice = (a, b) => { return a.gross - b.gross }
const sortByPriceDesc = (a, b) => { return b.gross - a.gross }
const sortByHotDeal = (a, b) => { return sortByPrice(a, b) }

export {
  sortByPrice,
  sortByPriceDesc,
  sortByHotDeal
}
